import { Check, Plus } from 'lucide-react';

import { cn } from '@/lib/utils';

interface CallPrepToggleProps {
  sourceId: string;
  callPrepText: string;
  isActive: boolean;
  onToggle: (sourceId: string, text: string) => void;
  className?: string;
}

export const CallPrepToggle = ({
  sourceId,
  callPrepText,
  isActive,
  onToggle,
  className,
}: CallPrepToggleProps) => (
  <button
    type="button"
    onClick={() => onToggle(sourceId, callPrepText)}
    className={cn(
      'ml-1 flex-shrink-0 rounded p-0.5 transition-all',
      isActive
        ? 'bg-amber-100 dark:bg-amber-900/40 text-amber-700 dark:text-amber-400'
        : 'text-zinc-400 opacity-0 group-hover:opacity-100 hover:bg-white dark:hover:bg-zinc-700 hover:text-zinc-700 dark:hover:text-zinc-300',
      className,
    )}
    aria-label={isActive ? 'Remove from call prep' : 'Add to call prep'}
  >
    {isActive ? (
      <Check className="h-3 w-3" />
    ) : (
      <Plus className="h-3 w-3" />
    )}
  </button>
);
